import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import { Gender } from "model/user/gender";

export interface MutateUserProfileParams {
  id: number;
  firstName: string;
  lastName: string;
  displayName: string;
  gender: Gender;
  avatar: string;
  dateOfBirth: string;
  countryId: number;
  emailAddress: string;
  phoneNumber: string;
  organizationId: number;
  languageId: number;
  timeZone: string,
}

export const mutateUserProfile = async (values: MutateUserProfileParams) => {
  const { id, ...rest } = values;
  const response = await makeMutation(
    ApiEndpoints.userProfile(),
    rest,
    true,
    "PATCH"
  );
  return { success: response.success };
};
